import { render, staticRenderFns } from "./CardCapture.vue?vue&type=template&id=1d93f492&scoped=true"
import script from "./CardCapture.vue?vue&type=script&lang=js"
export * from "./CardCapture.vue?vue&type=script&lang=js"
import style0 from "./CardCapture.vue?vue&type=style&index=0&id=1d93f492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93f492",
  null
  
)

export default component.exports